import { createSlice } from '@reduxjs/toolkit';
import { loginAction, getMeAction, changePasswordAction } from './auth.action';

const initialState: Auth.LoginState = {
  isLoading: false,
  error: null,
  meInfo: null,
  getMeLoading: false,
  infoFirstLogin: {
    username: '',
    password: '',
  },
};

const { actions, reducer } = createSlice({
  name: 'auth_slice',
  initialState,
  reducers: {
    logOut: state => {
      state.meInfo = null;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(loginAction.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(loginAction.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.firstLogin) {
          state.infoFirstLogin = action.meta.arg.data;
        }
      })
      .addCase(loginAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      })
      .addCase(changePasswordAction.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(changePasswordAction.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(changePasswordAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      })
      .addCase(getMeAction.pending, (state, action) => {
        state.getMeLoading = true;
      })
      .addCase(getMeAction.fulfilled, (state, action) => {
        state.getMeLoading = false;
        state.meInfo = action.payload;
      })
      .addCase(getMeAction.rejected, (state, action) => {
        state.getMeLoading = false;
        state.error = action.payload;
      });
  },
});

export { reducer };
export default actions;
